import { useEffect, useRef, useState } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAlert from "components/MDAlert";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Table from "@mui/material/Table";
import DataTable from "../../../examples/Tables/DataTable";
import data from "../../dashboard/components/Projects/data";
import useApi from "../../../components/Utils/api";
import MDInput from "../../../components/MDInput";
import toast from "react-hot-toast";
import * as React from "react";
import {Controller, FormProvider, useForm} from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { mdrDefaultModel, mdrDefaultSchema } from "../../../models/MdrDefaultMaster";
import {FormControl, InputLabel, Select} from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import PermissionControl from "../../../components/Utils/PermissionControl";

function MdrDefaultMaster() {
  const [masters, setMasters] = useState([]);
  const { register, handleSubmit, reset, formState: { errors }, trigger, watch, control, setValue } = useForm({
    mode: "onChange",
    resolver: yupResolver(mdrDefaultSchema),
  });
  const api = useApi();

  function updateMasterHandler(data) {
    api.post("master/updateDefaultMdrMaster", data)
      .then(response => {
        if(response.data.statusCodeValue === 200){
          toast.success(response.data.body.message);
        }
      })
      .catch(error => {
        toast.error(error.response.data.body);
      })
  }

  function updateMasterICCHandler(data) {
    api.post("master/updateDefaultMdrMasterICC", data)
      .then(response => {
        if(response.data.statusCodeValue === 200){
          toast.success(response.data.body.message);
        }
      })
      .catch(error => {
        toast.error(error.response.data.body);
      })
  }
const submitHandler = () => {
    handleSubmit(updateMasterHandler)();
}

const submitHandlerIC = () => {
  handleSubmit(updateMasterICCHandler)();
}
  const getMasters = () => {
    api.post("master/getDefaultMdrMaster")
      .then((response) => {
        if(response.data.statusCodeValue === 200) {
          setMasters(response.data.body[0]);
          reset(response.data.body[0]);
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === 403) {
          toast.error("You do not have permission to perform this action.");
          return;
        }
        toast.error(error.response.data.body);
      })
  }
  useEffect(() => {
      getMasters();
  },[]);
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mt={6} mb={3}>
        <Grid container spacing={3} justifyContent="center">
          <FormProvider {...{ register, handleSubmit, reset, formState: { errors }, trigger, watch, control }}>
            {/* Blended MSF heading */}
            <Grid item xs={12}>
              <h5>Blended MSF</h5>
            </Grid>
            
            {/* Cardholder Surcharge input */}
            <Grid item xs={4}>
              <MDInput
                type="text" label="Cardholder Surcharge (%)" name="cardHoldercharger"
                error={errors.cardHoldercharger}
                helperText={errors.cardHoldercharger ? errors.cardHoldercharger.message : ''}
                fullWidth
                {...register("cardHoldercharger")}
              />
            </Grid>
            
            {/* Merchant Service Fee input */}
            <Grid item xs={4}>
              <MDInput
                type="text" label="Merchant Service Fee (%)" name="merchantMDr"
                error={errors.merchantMDr}
                helperText={errors.merchantMDr ? errors.merchantMDr.message : ''}
                fullWidth
                {...register("merchantMDr")}
              />
            </Grid>
            
            {/* Settlement Type select */}
            <Grid item xs={4}>
              <FormControl fullWidth style={{height: '100%'}}>
                {<Controller
                    name="settlementType"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            label="Settlement Type"
                            fullWidth
                            {...field}
                            error={!!errors.settlementType}
                            helperText={errors.settlementType ? errors.settlementType.message : ''}
                            style={{height: '100%'}}
                        >
                          <MenuItem value=""> -Select Settlement Type- </MenuItem>
                          <MenuItem value="GROSS"> Gross Settlement </MenuItem>
                          <MenuItem value="NET"> Net Settlement </MenuItem>
                        </Select>
                    )}
                /> }
              </FormControl>
            </Grid>
            
          </FormProvider>
          <Grid container justifyContent="flex-end" style={{ marginTop: '10px'}}>
            <PermissionControl permission={{ restrict: true, module: "Masters", subModule: "UpdateDefaultMdrMaster" }}>
              <MDButton variant="gradient" onClick={() => submitHandler()} color="info" style={{marginBottom: "12px"}}>
                Update
              </MDButton>
            </PermissionControl>
          </Grid>


          
        </Grid>
      </MDBox>
      <MDBox mt={6} mb={3}>
        <Grid container spacing={3} >
          <FormProvider {...{ register, handleSubmit, reset, formState: { errors }, trigger, watch, control }}>
            {/* Blended MSF heading */}
            <Grid item xs={12}>
              <h5>IC++ MSF</h5>
            </Grid>
            <Grid item xs={12}>
              <h8>Cardholder Surcharge</h8>
            </Grid>
            
            {/* Cardholder Surcharge input */}
            <Grid item xs={4}>
              <MDInput
                type="text" label="eftpos ($)" name="eftpos"
                error={errors.eftpos}
                helperText={errors.eftpos ? errors.eftpos.message : ''}
                fullWidth
                {...register("eftpos")}
              />
            </Grid>
            <Grid item xs={4}>
              <MDInput
                type="text" label="Visa Credit (%)" name="visaCredit"
                error={errors.visaCredit}
                helperText={errors.visaCredit ? errors.visaCredit.message : ''}
                fullWidth
                {...register("visaCredit")}
              />
            </Grid>
            <Grid item xs={4}>
              <MDInput
                type="text" label="MasterCard Credit (%)" name="masterCredit"
                error={errors.masterCredit}
                helperText={errors.masterCredit ? errors.masterCredit.message : ''}
                fullWidth
                {...register("masterCredit")}
              />
            </Grid>
            <Grid item xs={4}>
              <MDInput
                type="text" label="MasterCard Debit (%)" name="masterDebit"
                error={errors.masterDebit}
                helperText={errors.masterDebit ? errors.masterDebit.message : ''}
                fullWidth
                {...register("masterDebit")}
              />
            </Grid>
            <Grid item xs={4}>
              <MDInput
                type="text" label="AMEX(%)" name="amex"
                error={errors.amex}
                helperText={errors.amex ? errors.amex.message : ''}
                fullWidth
                {...register("amex")}
              />
            </Grid>
            <Grid item xs={4}>
              <MDInput
                type="text" label="UPI (%)" name="upi"
                error={errors.upi}
                helperText={errors.upi ? errors.upi.message : ''}
                fullWidth
                {...register("upi")}
              />
            </Grid>

            <Grid item xs={4}>
              <MDInput
                type="text" label="Diners (%)" name="diners"
                error={errors.diners}
                helperText={errors.diners ? errors.diners.message : ''}
                fullWidth
                {...register("diners")}
              />
            </Grid>


            <Grid item xs={4}>
              <MDInput
                type="text" label="JCB (%)" name="jcb"
                error={errors.jcb}
                helperText={errors.jcb ? errors.jcb.message : ''}
                fullWidth
                {...register("jcb")}
              />
            </Grid>
            <Grid item xs={12}>
        <h8>Merchant Service Fee (%)</h8>
      </Grid>
            <Grid item xs={4}>
              <MDInput
                type="text" label="eftpos ($)" name="eftposMsf"
                error={errors.eftposMsf}
                helperText={errors.eftposMsf ? errors.eftposMsf.message : ''}
                fullWidth
                {...register("eftposMsf")}
              />
            </Grid>

            <Grid item xs={4}>
              <MDInput
                type="text" label="others (%)" name="others"
                error={errors.others}
                helperText={errors.others ? errors.others.message : ''}
                fullWidth
                {...register("others")}
              />
            </Grid>
            
            {/* Settlement Type select */}
        
            
          </FormProvider>
          <Grid container justifyContent="flex-end" style={{ marginTop: '10px'}}>
            <PermissionControl permission={{ restrict: true, module: "Masters", subModule: "UpdateDefaultMdrMaster" }}>
              <MDButton variant="gradient" onClick={() => submitHandlerIC()} color="info" style={{marginBottom: "12px"}}>
                Update
              </MDButton>
            </PermissionControl>
          </Grid>


          
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
  
}

export default MdrDefaultMaster;
